import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentVariablesService {
  public TAG_MANAGER_GTM: string = 'GTM-M9X3H37';

  public HOST: string = 'https://localhost:44337/';
  public OKTA_LOGOUT_SSO: string = '';
  public OKTA_CLIENT_ID: string = '0oa15hlm5sz4ccZWg0h8';
  public OKTA_ISSUER: string =
    'https://sit-login.alliancewebs.net/oauth2/auslliad098ikdxec0h7';
  public OKTA_AUDIENCE: string = 'api://Vizient';

  public OKTA_CALLBACK_PATH: string = '/callback';
  public OKTA_LOGOUT_PATH: string = this.OKTA_ISSUER + '/logout';
  public FUNCTION_URL: string = 'https://localhost:44337/';
  public GOOGLE_ANALYTICS_KEY: string = '1126E3LTFF';
  public IS_PROD: boolean = false;
  public IS_STAGE: boolean = false;
  public IS_TEST: boolean = false;
  public IS_DEV: boolean = false;

  public SPLIT_KEY: string = '811uisbkbdgl0188j3t5ocs7jd9lev83ti8m';

  public PRODUCT_ID: string = '3585';
  public APPLICATION_NAME: string = 'MDMCrossRefConsumption';
  public NOTIFICATIONS_URL: string = '';

  public IAM_URI: string =
    'https://alliancewebs.oktapreview.com/oauth2/ausggo44ehCrXSzAJ0h7';
  public IAM_QUERY: string =
    '?include_linked_orgs=true&include_classes_of_trade=true&include_product_roles=true';
  public IAM_AUDIENCE: string = 'api://iamservice';

  constructor() {
    this.setData();
  }
  public setData(): void {
    const baseUrl = window.location.origin;
    this.IS_PROD = baseUrl.toLowerCase().search('mdmxref.vizientinc') >= 0;
    this.IS_DEV = baseUrl.toLowerCase().search('mdmxref.dev') >= 0;
    this.IS_TEST = baseUrl.toLowerCase().search('mdmxref.test') >= 0;
    this.IS_STAGE = baseUrl.toLowerCase().search('mdmxref.stage') >= 0;

    if (this.IS_DEV) this.setDevValues();
    if (this.IS_TEST) this.setTestValues();
    if (this.IS_STAGE) this.setStageValues();
    if (this.IS_PROD) this.setProdValues();
  }
  private setDevValues() {
    this.GOOGLE_ANALYTICS_KEY = '1126E3LTFF';

    this.OKTA_LOGOUT_SSO = '';
    this.OKTA_CLIENT_ID = '0oa15hlm5sz4ccZWg0h8';
    this.OKTA_ISSUER =
      'https://sit-login.alliancewebs.net/oauth2/auslliad098ikdxec0h7';
    this.OKTA_AUDIENCE = 'api://Vizient';
    this.OKTA_CALLBACK_PATH = '/callback';
    this.OKTA_LOGOUT_PATH = this.OKTA_ISSUER + '/logout';
    this.FUNCTION_URL = 'https://mdmxref.dev.vizientinc.com/';
    this.HOST = 'https://mdmxref.dev.vizientinc.com/';

    this.IAM_URI =
      'https://alliancewebs.oktapreview.com/oauth2/ausggo44ehCrXSzAJ0h7';
    this.IAM_QUERY =
      '?include_linked_orgs=true&include_classes_of_trade=true&include_product_roles=true';
    this.IAM_AUDIENCE = 'api://iamservice';

    this.SPLIT_KEY = '811uisbkbdgl0188j3t5ocs7jd9lev83ti8m';

    this.TAG_MANAGER_GTM = 'GTM-M9X3H37';
  }
  private setTestValues() {
    this.GOOGLE_ANALYTICS_KEY = 'G-B7MKFB0KPH';

    this.OKTA_LOGOUT_SSO = '';
    this.OKTA_CLIENT_ID = '0oa15hlm5sz4ccZWg0h8';
    this.OKTA_ISSUER =
      'https://sit-login.alliancewebs.net/oauth2/auslliad098ikdxec0h7';
    this.OKTA_AUDIENCE = 'api://Vizient';
    this.OKTA_CALLBACK_PATH = '/callback';
    this.OKTA_LOGOUT_PATH = this.OKTA_ISSUER + '/logout';
    this.FUNCTION_URL = 'https://mdmxref.test.vizientinc.com/';
    this.HOST = 'https://mdmxref.test.vizientinc.com/';

    this.NOTIFICATIONS_URL = 'https://notification.test.vizientinc.com';

    this.IAM_URI =
      'https://alliancewebs.oktapreview.com/oauth2/ausggo44ehCrXSzAJ0h7';
    this.IAM_QUERY =
      '?include_linked_orgs=true&include_classes_of_trade=true&include_product_roles=true';
    this.IAM_AUDIENCE = 'api://iamservice';

    this.SPLIT_KEY = '7chdp3ovvdbaq732ulcn46pdhdgka9hv253l';

    this.TAG_MANAGER_GTM = 'GTM-TDNXF3Q';
  }
  private setStageValues() {
    this.GOOGLE_ANALYTICS_KEY = 'V38Q68JBE2';

    this.OKTA_LOGOUT_SSO = '';
    this.OKTA_CLIENT_ID = '0oa15hlm5sz4ccZWg0h8';
    this.OKTA_ISSUER =
      'https://sit-login.alliancewebs.net/oauth2/auslliad098ikdxec0h7';
    this.OKTA_AUDIENCE = 'api://Vizient';
    this.OKTA_CALLBACK_PATH = '/callback';
    this.OKTA_LOGOUT_PATH = this.OKTA_ISSUER + '/logout';
    this.FUNCTION_URL = 'https://mdmxref.stage.vizientinc.com/';
    this.HOST = 'https://mdmxref.stage.vizientinc.com/';

    this.NOTIFICATIONS_URL = 'https://notification.stage.vizientinc.com';

    this.IAM_URI =
      'https://alliancewebs.oktapreview.com/oauth2/ausggo44ehCrXSzAJ0h7';
    this.IAM_QUERY =
      '?include_linked_orgs=true&include_classes_of_trade=true&include_product_roles=true';
    this.IAM_AUDIENCE = 'api://iamservice';

    this.SPLIT_KEY = '5gl05oqqos5jivgcbj3db8e89mv27vc9n8q5';

    this.TAG_MANAGER_GTM = 'GTM-NZ6TXFKK';
  }
  private setProdValues() {
    this.GOOGLE_ANALYTICS_KEY = 'YK909T9EBV';

    this.OKTA_LOGOUT_SSO = '';
    this.OKTA_CLIENT_ID = '0oauvii8joSO6LGYS0x7';
    this.OKTA_ISSUER =
      'https://login.alliancewebs.net/oauth2/ausmkot3jmgtQXrtZ0x7';
    this.OKTA_AUDIENCE = 'api://Vizient';
    this.OKTA_CALLBACK_PATH = '/callback';
    this.OKTA_LOGOUT_PATH = this.OKTA_ISSUER + '/logout';
    this.FUNCTION_URL = 'https://mdmxref.vizientinc.com/';
    this.HOST = 'https://mdmxref.vizientinc.com/';

    this.NOTIFICATIONS_URL = 'https://notification.vizientinc.com';

    this.IAM_URI = 'https://alliancewebs.okta.com/oauth2/auslsd6hlkLAt2VJt0x7';
    this.IAM_QUERY =
      '?include_linked_orgs=true&include_classes_of_trade=true&include_product_roles=true';
    this.IAM_AUDIENCE = 'api://iamservice';

    this.SPLIT_KEY = 'b8rp7rki51c4735bktm1nkcupinsgjd7v7j1';

    this.TAG_MANAGER_GTM = 'GTM-P7SLQ655';
  }
}
